import { render, staticRenderFns } from "./StudentCourse.vue?vue&type=template&id=7e4307f8&scoped=true&"
import script from "./StudentCourse.vue?vue&type=script&lang=ts&"
export * from "./StudentCourse.vue?vue&type=script&lang=ts&"
import style0 from "./StudentCourse.vue?vue&type=style&index=0&id=7e4307f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4307f8",
  null
  
)

export default component.exports